import SceneObject from "../scene/sceneobject";
import { BoundingSphere } from "./bounding_sphere";
import { CollisionVolume } from "./collision_volume";
import Attachment from "../animation/attachment";

export default class SphereCollisionVolume implements CollisionVolume {
  owner: SceneObject | null = null;
  layer: string;
  isTrigger: boolean;
  name: string;

  localCenter: Float32Array;
  radius: number;

  attachment: Attachment | null = null;

  constructor(
    localCenter: Float32Array,
    radius: number,
    layer = "default",
    isTrigger = false,
    name = ""
  ) {
    this.localCenter = localCenter;
    this.radius = radius;
    this.layer = layer;
    this.isTrigger = isTrigger;
    this.name = name;
  }

  getWorldSphere(): BoundingSphere | null {
    if (this.attachment) {
      return {
        center: new Float32Array([
          this.attachment.world_position[0] + this.localCenter[0],
          this.attachment.world_position[1] + this.localCenter[1],
          this.attachment.world_position[2] + this.localCenter[2],
        ]),
        radius: this.radius,
      };
    }

    if (!this.owner) return null;

    const p = this.owner.transform.position;

    return {
      center: new Float32Array([
        p[0] + this.localCenter[0],
        p[1] + this.localCenter[1],
        p[2] + this.localCenter[2],
      ]),
      radius: this.radius,
    };
  }

  getWorldAabb(): null {
    return null;
  }
}